/**
 * useInventoryGroupListScreen.js
 * ------------------------------
 * Hook for Inventory Group Master list screen using shared useMasterList
 * and asynchronous JobEngine export.
 */
import { useMasterList } from '../../common/useMasterList';
import * as inventoryGroupApi from '../api/inventoryGroupApi';
import { useExportJob } from '../../../../hooks/useExportJob';

export function useInventoryGroupListScreen() {
  const master = useMasterList({
    entityName: 'Inventory Group',
    apiClient: inventoryGroupApi.inventoryGroupClient,
    fetchList: inventoryGroupApi.listInventoryGroups,
    archiveItem: inventoryGroupApi.archiveInventoryGroup,
    deleteItem: inventoryGroupApi.deleteInventoryGroup,
  });

  const { triggerExport, isExporting } = useExportJob({
    module: 'inventory_group',
    fileFormat: 'XLSX',
  });

  const handleToolSelect = (toolKey) => {
    if (toolKey === 'download' || toolKey === 'export_excel') {
      triggerExport({
        viewMode: master.state.viewMode,
        searchText: master.state.searchText,
      });
    }
  };

  return {
    ...master,
    state: {
      ...master.state,
      isExporting,
    },
    actions: {
      ...master.actions,
      handleToolSelect,
    },
  };
}
